export default "__VITE_ASSET__TYpTFau3__"